

export type ToggleKey = 'global' | 'state' | 'modules' | 'providers'

export const ARTEFACT_ROWS: { key: Exclude<ToggleKey, 'global'>; label: string; sublabel: string }[] = [
  { key: 'modules',   label: 'Modules',   sublabel: 'Enforced on module downloads.' },
  { key: 'state',     label: 'State',     sublabel: 'Blocks the next apply (LOCK) until an admin attests the fix.' },
  { key: 'providers', label: 'Providers', sublabel: 'Enforced on self-built and patched provider downloads.' },
]
